import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["memoForm", "memoTextarea"]

  connect() {
  }

  closeModal() {
    // DaisyUIのモーダル閉じる方法: modal-openクラスを削除
    this.element.classList.remove('modal-open')
    document.body.classList.remove('modal-open')
  }

  saveMemo(event) {
    event.preventDefault()
    
    // データ属性から情報を取得
    const memoUrl = this.element.dataset.currentMemoUrl
    const tweetId = this.element.dataset.currentTweetId
    const clTwKeywordId = this.element.dataset.currentClTwKeywordId
    const rowId = this.element.dataset.currentRowId
    
    if (!memoUrl) {
      this.showNotification('保存先のURLが設定されていません', 'error')
      return
    }
    
    const memoContent = this.memoTextareaTarget.value
    
    const formData = new FormData()
    formData.append('tweet_id', tweetId)
    formData.append('cl_tw_keyword_id', clTwKeywordId)
    formData.append('memo', memoContent)

    fetch(memoUrl, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === 'ok') {
        this.showNotification('メモを保存しました', 'success')
        this.updateMemoDisplay(memoContent, rowId)
        this.closeModal()
      } else {
        this.showNotification('メモの保存に失敗しました', 'error')
      }
    })
    .catch(error => {
      console.error('Error:', error)
      this.showNotification('メモの保存に失敗しました', 'error')
    })
  }

  updateMemoDisplay(memoContent, rowId) {
    const rowElement = document.getElementById(rowId)
    if (!rowElement) return
    
    const memoCell = rowElement.querySelector('td:last-child')
    const memoContainer = memoCell.querySelector('.flex')
    const memoSpan = memoContainer.querySelector('span')
    
    if (memoContent.trim()) {
      const displayText = memoContent.length > 16 ? `${memoContent.substring(0, 16)}...` : memoContent
      memoSpan.textContent = displayText
      memoSpan.setAttribute('title', memoContent)
      memoSpan.className = 'text-xs truncate max-w-16'
    } else {
      memoSpan.textContent = '未設定'
      memoSpan.removeAttribute('title')
      memoSpan.className = 'text-xs text-base-content/50'
    }
  }

  showNotification(message, type) {
    // DaisyUI toast風の通知を表示
    const toast = document.createElement('div')
    toast.className = `alert alert-${type === 'success' ? 'success' : 'error'} fixed top-4 right-4 w-auto z-50 shadow-lg`
    toast.innerHTML = `
      <span class="iconify ${type === 'success' ? 'lucide--check-circle' : 'lucide--x-circle'} size-4"></span>
      <span>${message}</span>
    `
    
    document.body.appendChild(toast)
    
    // 3秒後に削除
    setTimeout(() => {
      toast.remove()
    }, 3000)
  }
}